import React from 'react';
import { InputAdornment } from '@mui/material';

interface CompoundInterestInputSuffixProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export const CompoundInterestInputSuffix: React.FC<CompoundInterestInputSuffixProps> = ({ children, style }) => (
    <InputAdornment position="end">
        <span
            className="flex h-[4rem] min-w-[4rem] items-center justify-center rounded-[99rem] px-[0.75rem] text-small font-bold text-neutral-gray"
            style={style}
        >
            {children}
        </span>
    </InputAdornment>
);
